import { createSelector } from "@reduxjs/toolkit";
import { PLATFORM_SETTINGS_FEATURE_KEY } from "./shared-platform-settings-feature-keys.js";
const getPlatformSettingsState = (rootState) => rootState[PLATFORM_SETTINGS_FEATURE_KEY] || {};
const selectCryptoCurrencyEnabled = createSelector(
  getPlatformSettingsState,
  ({ cryptoCurrencyEnabled }) => cryptoCurrencyEnabled
);
const selectNotificationsEnabled = createSelector(
  getPlatformSettingsState,
  (s) => s.notificationsEnabled
);
const selectNonAuthTimestamp = createSelector(
  getPlatformSettingsState,
  (s) => s == null ? void 0 : s.nonAuthTimestamp
);
export {
  getPlatformSettingsState,
  selectCryptoCurrencyEnabled,
  selectNonAuthTimestamp,
  selectNotificationsEnabled
};
